import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormBrandService {

  constructor(
    private http: HttpClient,
  ) {

  }

  private brandSettings$ = new BehaviorSubject<any>(null);
  public brandSettings: Observable<any> = this.brandSettings$.asObservable();

  async getFormBrandSettings(BrandID: string, DisclosID: string, CO: string) {
    try {
      const res = await this.fetchFormBrandSettings(BrandID, DisclosID);      
      res.CO = CO;
      this.brandSettings$.next(res);
      return res;
    } catch (error) {    
        throw error;
    }
  }

  getCachedFormBrandSettings(): any {
    return this.brandSettings$.getValue();
  }
    
  private async fetchFormBrandSettings(BrandID: string, DisclosID: string): Promise<any> {

  var AnyToken = null;
  AnyToken = '39c1d50f-28b6-4472-b4a5-69a73f6080e4';

  const dataObj = {
    BrandID: BrandID,
    DisclosID: DisclosID,
  };


  const config = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'withCredentials': 'true',
      'Authorization': 'true',
      'Token': AnyToken
    })
  };

  try {
    return await this.http.post<any>(`https://landinghelper.azurewebsites.net/api/GetTPCAText`, JSON.stringify(dataObj),config).toPromise();

  } catch (error) {
    console.error('Error fetching form data:', error);
    throw error;
  }
  }

  getFormBrandSettingsObservable(): Observable<any> {
    return this.brandSettings$.asObservable();
  }

}
